// Valid product tags that can be displayed on cards
export enum ProductTag {
  BEST_SELLER = 'Best Seller',
  NEW_ARRIVAL = 'New Arrival',
  POPULAR = 'Popular',
}

// Helper to check if a tag is valid for display
export function isValidProductTag(tag: string | undefined): tag is ProductTag {
  if (!tag) return false;
  return Object.values(ProductTag).includes(tag as ProductTag);
}

// Get display-safe tag (returns undefined if tag is not in enum)
export function getDisplayTag(tag: string | undefined): ProductTag | undefined {
  if (isValidProductTag(tag)) {
    return tag;
  }
  return undefined;
}

// Offer sub-model: represents a special offer/discount on a product
export interface Offer {
  originalPrice: number;    // Price before discount
  discount: number;         // Discount percentage (e.g., 15, 20, 25)
  offerName?: string;       // Optional custom name like "Bundle", "Mega Pack"
}

export interface Product {
  id: string;
  name: string;
  price: number;            // Current/final price (discounted if offer exists)
  image: string;
  backImage?: string;
  description?: string;
  ingredients?: string;
  images?: string[];
  tag?: string;             // Raw tag from CSV (may not be in enum)
  isOffer?: boolean;        // Helper flag from CSV
  offer?: Offer | null;     // If present, product has an active offer
  weight?: string;          // Product weight (e.g., "60g", "100g")
}

export interface CartItem extends Product {
  quantity: number;
}
